import { useEffect, useState } from 'react';
import { Clock3 } from 'lucide-react';

export default function BraceletGiftCountdown({ expiresAt, small = false, hero = false }: { expiresAt: number; small?: boolean; hero?: boolean }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  if (!expiresAt || expiresAt <= now) return null;
  const secondsLeft = Math.ceil((expiresAt - now) / 1000);
  const days = Math.floor(secondsLeft / 86400);
  const hours = Math.floor((secondsLeft % 86400) / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const seconds = secondsLeft % 60;
  const pad = (value: number) => String(value).padStart(2, '0');

  if (hero) return <div className="inline-flex min-h-[55px] flex-col justify-center rounded-xl border border-[#e7c584] bg-[#fffaf0]/95 px-3 py-1.5 text-[#703510] shadow-[0_12px_30px_-12px_rgba(92,52,18,0.35)] sm:min-h-[82px] sm:rounded-2xl sm:px-5 sm:py-3" aria-label={`Gift promotion ends in ${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds`}>
    <span className="flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.1em] sm:gap-2 sm:text-xs"><Clock3 className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" /> Limited time offer</span>
    <span className="mt-0.5 text-sm font-bold tabular-nums sm:mt-1 sm:text-xl">{days > 0 ? `${days}d ` : ''}{pad(hours)}h {pad(minutes)}m {pad(seconds)}s</span>
  </div>;

  return <div className={`inline-flex items-center gap-2 border border-amber-300 bg-white font-semibold text-amber-950 tabular-nums ${small ? 'rounded-lg px-3 py-2 text-xs' : 'rounded-xl px-4 py-3 text-sm shadow-sm'}`} aria-label={`Gift promotion ends in ${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds`}>
    <Clock3 className={small ? 'h-4 w-4 text-amber-800' : 'h-5 w-5 text-amber-800'} aria-hidden="true" />
    <span>Offer ends in <strong className="ml-1">{days > 0 ? `${days}d ` : ''}{pad(hours)}:{pad(minutes)}:{pad(seconds)}</strong></span>
  </div>;
}
